'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_sjs_js_ArrayOps$() {
}
export { $c_sjs_js_ArrayOps$ as $c_sjs_js_ArrayOps$ };
$p = $c_sjs_js_ArrayOps$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_sjs_js_ArrayOps$;
/** @constructor */
function $h_sjs_js_ArrayOps$() {
}
export { $h_sjs_js_ArrayOps$ as $h_sjs_js_ArrayOps$ };
$h_sjs_js_ArrayOps$.prototype = $p;
$p.V9 = (function(this$) {
  return (((this$.length | 0) === 0) ? $j_java$002elang$002e$002dObject.$m_s_None$() : new $j_java$002elang$002e$002dObject.$c_s_Some(this$[0]));
});
$p.Vb = (function(this$, elem, from) {
  var len = (this$.length | 0);
  var i = from;
  while ((i < len)) {
    if ($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(elem, this$[i])) {
      return i;
    }
    i = ((1 + i) | 0);
  }
  return (-1);
});
$p.SW = (function(this$, elem) {
  return ($m_sjs_js_ArrayOps$().Vb(this$, elem, 0) >= 0);
});
var $d_sjs_js_ArrayOps$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_sjs_js_ArrayOps$, "scala.scalajs.js.ArrayOps$", ({
  vQ: 1
}));
export { $d_sjs_js_ArrayOps$ as $d_sjs_js_ArrayOps$ };
var $n_sjs_js_ArrayOps$;
function $m_sjs_js_ArrayOps$() {
  if ((!$n_sjs_js_ArrayOps$)) {
    $n_sjs_js_ArrayOps$ = new $c_sjs_js_ArrayOps$();
  }
  return $n_sjs_js_ArrayOps$;
}
export { $m_sjs_js_ArrayOps$ as $m_sjs_js_ArrayOps$ };
